import { withFormik } from "formik";
import * as Yup from "yup";
const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/svg",
  "image/gif"
];
const formikEnhancer = withFormik({
  validationSchema: props =>
    Yup.object().shape({
      name: Yup.string().required("Please Enter Name"),
      username: Yup.string().required("Please Enter User Name"),
      password: Yup.string()
        .min(8, "Password must be atleast 8 characters.")
        .required("Please Enter Password"),
      // file_image is optional; validate format if provided
      file_image: Yup.mixed().test(
        "fileFormat",
        "Only JPG, JPEG, PNG, SVG and GIF files are allowed.",
        value =>
          !value ||
          typeof value === "string" ||
          SUPPORTED_FORMATS.includes(value?.type)
      ),
      // image_galary is optional; if provided, enforce limits and formats
      image_galary: Yup.array()
        .max(10, "You can upload a maximum of 10 images")
        .test(
          "fileFormat",
          "Only JPG, JPEG, PNG, SVG and GIF files are allowed.",
          value =>
            !value ||
            value.length === 0 ||
            value.every(
              file =>
                typeof file === "string" ||
                (file && SUPPORTED_FORMATS.includes(file.type))
            )
        ),
      staff_data: Yup.array().min(1, "Please select staff"),
      service_data: Yup.array().min(1, "Please select service"),
      status: Yup.string().required("Please select status")
    }),
  mapPropsToValues: props => ({
    name: "",
    username: "",
    password: "",
    file_image: "",
    image_galary: [],
    staff_data: [],
    service_data: [],
    status: true
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
